exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.qwpt[data-v-bd484914] {\n    padding-top: 54px;\n    height: 150px;\n}\n", ""]);

// exports
